import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'kla-simple-progressbar',
  templateUrl: './simple-progressbar.component.html',
  styleUrls: ['./simple-progressbar.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class SimpleProgressbarComponent {
  @Input() color = '#2dadde';
  @Input() value: number;
}
